export const ROUTES_DEFAULT_CITY_ALIAS = 'moscow';
export const ROUTES_DEFAULT_CITY_ID = 110;
